<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <div>
          <v-toolbar flat>
            <GmapAutocomplete
              ref="autocompleteRef"
              placeholder="ค้นหาสถานที่"
              id="pac-input"
              @place_changed="setPlace"
              :options="autocompleteOption"
            />
            <v-spacer></v-spacer>
            <v-btn
              v-if="markers.length > 0"
              class="primary mr-3"
              @click="onSubmit"
              >ตกลง</v-btn
            >
            <v-btn outlined @click="onCancel">ยกเลิก</v-btn>
          </v-toolbar>
          <GmapMap
            ref="mapRef"
            :center="mapCenter"
            :zoom="mapZoom"
            :map-type-id="mapType"
            @click="addNewMarker($event)"
            style="width: 100%; height: calc(100vh - 64px)"
          >
            <GmapMarker
              v-for="(m, index) in markers"
              :key="index"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @dragend="setMarker($event, index)"
              @click="getInfoMarker($event)"
            />

            <GmapInfoWindow
              @closeclick="infoWindowOpen = false"
              :opened="infoWindowOpen"
              :position="infoWindowPosition"
              :options="{ pixelOffset: { width: 0, height: -35 } }"
              >{{ infoWindowPosition }}</GmapInfoWindow
            >
          </GmapMap>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'GoogleMap',

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mapZoom: 18,
      mapType: 'roadmap',
      infoWindowOpen: false,
      infoWindowPosition: null,
      autocompleteOption: {
        componentRestrictions: { country: 'th' },
        fields: ['formatted_address', 'geometry', 'name'],
        strictBounds: false,
        types: ['establishment'],
      },
    }
  },

  computed: {
    mapCenter() {
      return this.$store.state.googleMap.mapCenter
    },
    markers() {
      return this.$store.state.googleMap.markers
    },
  },

  methods: {
    onSubmit() {
      this.$emit('onSubmit')
    },
    onCancel() {
      this.$emit('onCancel')
    },
    updateMarker(position) {
      this.infoWindowOpen = false

      const markers = []
      markers.push({ position })
      this.$store.commit('googleMap/SET_MARKERS', markers)
    },
    addNewMarker(event) {
      const position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      this.updateMarker(position)
    },

    setMarker(event) {
      const position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      this.updateMarker(position)
    },

    getInfoMarker(event) {
      this.infoWindowOpen = true
      this.infoWindowPosition = event.latLng
    },

    setPlace(place) {
      const position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }
      this.updateMarker(position)

      this.$store.commit('googleMap/SET_MAP_CENTER', position)
      this.$refs.autocompleteRef.$refs.input.value = ''
    },
  },
}
</script>

<style scoped>
#pac-input {
  border: solid 1px #555;
  border-radius: 3px;
  padding: 5px 10px;
  width: 520px;
}
</style>
